import React, { useEffect, useState } from 'react';
import Form from '@rjsf/core';
import { Tile, notification, Row, Col, Button } from '@cv/eds-react';
import { RJSFSchema, UiSchema, RegistryWidgetsType, ErrorListProps } from '@rjsf/utils';
import {
  CustomEDSCheckbox,
  CustomEDSInput,
  CustomEDSSelect
} from '../CustomEDSComponents';
import validator from '@rjsf/validator-ajv8';
import { Card } from 'react-bootstrap';
import useGetSeverityTypeSchema from '../../hooks/useGetSeverityTypeSchema';
import useCustomerData from '../../Context/CustomerDataContext';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import '../Visualisations/EditVisualisationformcss.css';
import usePostSeverityRule from '../../hooks/usePostSeverityRule';
import useGetSeverityRule from '../../hooks/useGetSeverityRule';

const AddEditSeverityRule = (props) => {
  const { customer } = useCustomerData();
  const severityType = props?.location?.state ? props.location.state : '';
  const history = useHistory();
  const location = useLocation();
  const [schema, setSchema] = useState({});
  const [data, setData] = useState(null);
  const [formDataJson, setFormDataJson] = useState({});
  const { data: addData, isLoading: isLoadingAddData } = useGetSeverityTypeSchema(
    customer,
    severityType
  );

  const { severityRuleId } = useParams();
  const { data: editData, isLoading: isLoadingEditData } = useGetSeverityRule(
    customer,
    severityRuleId
  );
  const { mutateAsync } = usePostSeverityRule(customer);

  function transformErrors(errors, uiSchema) {
    return errors.map((error) => {
      return error;
    });
  }
  function ErrorListTemplate(props: ErrorListProps) {
    const { errors } = props;
    return <></>;
  }

  const uiSchemaObject: UiSchema = {
    'ui:classNames': 'custom-form',
    id: {
      'ui:widget': 'hidden',
      classNames: 'custom-field'
    },
    type: {
      classNames: 'custom-field',
      'ui:disabled': true
    },
    name: {
      classNames: 'custom-field'
    },
    active: {
      classNames: 'custom-field'
    },
    priority: {
      classNames: 'custom-field'
    },
    severity: {
      classNames: 'custom-field'
    },
    filter: {
      'ui:classNames': 'mt-3 mb-5 custom-field position-relative array-without-object',
      'ui:options': {
        orderable: false
      },
      items: {
        condition: {
          classNames: 'custom-field'
        },
        field: {
          classNames: 'custom-field',
          'ui:disabled': true
        },
        value: {
          classNames: 'custom-field mb-5 custom-array-with-object-type1'
        }
      }
    }
  };

  const handleSubmitObject = async ({ formData }, e) => {
    e.preventDefault();
    setFormDataJson(formData);
    try {
      const response = await mutateAsync(formData);
      if (response) {
        if (location.pathname === '/severity-rules/add') {
          notification.notice('Severity rule added successfully!!!');
        } else {
          notification.notice('Severity rule updated successfully!!!');
        }
        history.push('/severity-rules');
      }
    } catch (error) {
      setTimeout(() => {
        notification.notice(error?.response.data.message);
      }, 1000);
    }
  };

  const handleErrorObject = (e) => {};

  const widgets: RegistryWidgetsType = {
    TextWidget: CustomEDSInput,
    CheckboxWidget: CustomEDSCheckbox,
    SelectWidget: CustomEDSSelect
  };

  useEffect(() => {
    if (data?.data?.data) {
      setFormDataJson(data.data.data);
    }
  }, [data]);

  useEffect(() => {
    if (data?.data?.schema) {
      setSchema(data.data.schema);
    }
  }, [data]);

  useEffect(() => {
    if (location.pathname === '/severity-rules/add' && addData && !isLoadingAddData) {
      setData(addData);
    } else if (editData && !isLoadingEditData) {
      setData(editData);
    }
  }, [location, addData, editData]);

  useEffect(() => {
    if (location.pathname === '/severity-rules/add' && severityType === '') {
      history.replace('/severity-rules');
    }
  }, [location, severityType]);

  const schemaObject: RJSFSchema = schema ? schema : {};

  return (
    <div>
      <Tile title="Add Severity Rule">
        <Row>
          <Col span={6}>
            <Card>
              <Form
                schema={schemaObject}
                uiSchema={uiSchemaObject}
                onSubmit={handleSubmitObject}
                onError={handleErrorObject}
                widgets={widgets}
                formData={formDataJson}
                transformErrors={transformErrors}
                liveValidate
                templates={{ ErrorListTemplate }}
                validator={validator}
              >
                <Button
                  type="submit"
                  children={severityRuleId ? 'Save & Update' : 'Save'}
                />
              </Form>
            </Card>
          </Col>
        </Row>
      </Tile>
    </div>
  );
};

export default AddEditSeverityRule;
